// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__zw5nE","content":"LoadingAlert_content__gmJb1"};